
import * as Cesium from "cesium";

export const getEntityById = (viewer: Cesium.Viewer | null, dataSourceName: string, entityId: string) => {
    if (!viewer) return
    const dataSource = getDataSourceByName(viewer, dataSourceName)
    if (!dataSource) return
    const entity = dataSource.entities.getById(entityId);
    return entity
}

export const requestRender = (viewer: Cesium.Viewer | null) => {
    if (!viewer) return
    viewer.scene.requestRender();
    setTimeout(() => {
        viewer.scene.requestRender();
    }, 100);
}

export function setDataSourceVisibility(viewer: Cesium.Viewer | null, dataSourceName: string, visible: boolean) {
    if (!viewer) return
    const dataSources = viewer.dataSources;
    if (!dataSources) return
    for (let i = 0; i < dataSources.length; i++) {
        const dataSource = dataSources.get(i);
        if (dataSource.name === dataSourceName) {
            dataSource.show = visible;
            return
        }
    }
}

export const removeDataSourceByName = (viewer: Cesium.Viewer | null, dataSourceName: string) => {
    if (!viewer) return
    const dataSources = viewer.dataSources;
    if (!dataSources) return
    for (let i = 0; i < dataSources.length; i++) {
        const dataSource = dataSources.get(i);
        if (dataSource.name === dataSourceName) {
            dataSources.remove(dataSource, false);
            return
        }
    }
}

export const showHideDataSourceByName = (viewer: Cesium.Viewer | null, dataSourceName: string, show: boolean) => {
    if (!viewer) return;
    const dataSources = viewer.dataSources;
    if (!dataSources) return;

    for (let i = 0; i < dataSources.length; i++) {
        const dataSource = dataSources.get(i);
        if (dataSource.name === dataSourceName) {
            dataSource.show = show;
            return;
        }
    }
};

export function getDataSourceByName(viewer: Cesium.Viewer | null, dataSourceName: string) {
    if (!viewer) return
    const dataSources = viewer.dataSources;
    if (!dataSources) return
    for (let i = 0; i < dataSources.length; i++) {
        const dataSource = dataSources.get(i);
        if (dataSource.name === dataSourceName) {
            return dataSource;
        }
    }
    return null;
}

export const getOrbitAvailability = (viewer: Cesium.Viewer | null, datasourceName: string) => {
    if (!viewer) return
    const dataSource = getDataSourceByName(viewer, datasourceName);
    if (dataSource && dataSource.clock) {
        const start = dataSource.clock.startTime;
        const stop = dataSource.clock.stopTime;
        return `${start.toString()}/${stop.toString()}`
    }
}


// convert the position caoordinate to Cartographic Degrees
export const getCartographicDegrees = (position: any) => {
    let cartographicDegrees: any[] = [];
    position.forEach((element: any[]) => {
        cartographicDegrees.push(element[0]);
        cartographicDegrees.push(element[1]);
        cartographicDegrees.push(0);
    });
    return cartographicDegrees;
}

export const resizeViewerPosition = (viewer: Cesium.Viewer | null) => {
    if (!viewer) return
    setTimeout(() => {
        viewer.scene.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(0, 0, 35500000),
            orientation: {
                heading: Cesium.Math.toRadians(0.0),
                pitch: Cesium.Math.toRadians(0.0),
                roll: Cesium.Math.toRadians(0.0)
            }
        });
    }, 1000)
}